import { Form, Row } from "antd";
import { useEffect } from "react";
import { useSetting } from "../../util/settings";
import { AdvancedForm } from "../../form/advanced-form";
import FormItem from "../../form/form-item";

export const useGeneralSetting = () => {
  return useSetting("general", "application", {
    maxShoppingDistance: null,
  })
}

function GeneralSettings() {
  const [form] = Form.useForm();
  
  const [setting, updateSetting] = useGeneralSetting();

  useEffect(() => {
    form.setFieldsValue(setting);
  }, [form, setting])

  return (
    <AdvancedForm form={form} name="general_settings" onFinish={updateSetting} originalValues={setting}>
      <Row><h3>Allgemeine Einstellungen</h3></Row>
      <Row gutter={24}>
        <FormItem fieldName="maxShoppingDistance" label="Max. km Einkauf" type="number" />
        <FormItem fieldName="usersForTasks" label="Nutzer für Todos" type="user" typeData={{ multiple: true, noFilter: true }} />
      </Row>
    </AdvancedForm>
  )
}

export default GeneralSettings;